import fileDownload from 'js-file-download'
import context from '../context'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { fromUtcDate } from '@/utils/dateUtilities'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {
  fetching: false,
  generating: false,
  invalidating: false,
  deleting: false,
  rsaKeys: []
}

export const actionTypes = {
  fetching: 'rsaKeys/fetching',
  fetched: 'rsaKeys/fetched',
  generating: 'rsaKeys/generating',
  generated: 'rsaKeys/generated',
  invalidating: 'rsaKeys/invalidating',
  invalidated: 'rsaKeys/invalidated',
  deleting: 'rsaKeys/deleting',
  deleted: 'rsaKeys/deleted',
  error: 'rsaKeys/error'
}

const transformDates = (x) => ({
  ...x,
  creationTime: fromUtcDate(x.creationTime),
  invalidatedAt: fromUtcDate(x.invalidatedAt)
})
export const actionCreators = {
  getAll: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.fetching })
    context.api.cryptoService.getAll(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response.map(transformDates) })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  generateKeys: (passphrase) => (dispatch, getState) => {
    dispatch({ type: actionTypes.generating })
    context.api.cryptoService.generateRsaKeys({ passphrase }, allowErrorDialog)
      .then(response => {
        if (response.success === true) {
          dispatch({ type: actionTypes.generated, data: response.rsaKeys })
          fileDownload(response.privateKey, 'private-key.pem')
        } else {
          dispatch({ type: actionTypes.error, update: { generating: false } })
          dispatch(dialogActions.openDialog({ dialogType: dialogTypes.alert, content: response.errorMessage }))
        }
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { generating: false } }))
  },
  invalidateKey: (id) => (dispatch, getState) => {
    dispatch({ type: actionTypes.invalidating })
    context.api.cryptoService.invalidateKey({ id }, allowErrorDialog)
      .then(response => {
        if (response.success === true) {
          dispatch({ type: actionTypes.invalidated, data: response.rsaKeys })
        }
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { invalidating: false } }))
  },
  downloadPublicKey: (id) => () => {
    context.api.cryptoService.downloadPublicKey({ id }, allowErrorDialog)
      .then(response => {
        if (response.success === true) {
          fileDownload(response.publicKey, 'public-key.pem')
        }
      }).catch(() => {})
  },
  deleteRsaKey: (id) => (dispatch) => {
    dispatch({ type: actionTypes.deleting })
    context.api.cryptoService.deleteRsaKey(id, allowErrorDialog)
      .then(response => {
        if (response.success === true) {
          dispatch({ type: actionTypes.deleted, data: response.rsaKeys })
        }
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { deleting: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, rsaKeys: action.data }
    case actionTypes.generating: return { ...state, generating: true }
    case actionTypes.generated: return { ...state, generating: false, rsaKeys: action.data }
    case actionTypes.invalidating: return { ...state, invalidating: true }
    case actionTypes.invalidated: return { ...state, invalidating: false, rsaKeys: action.data }
    case actionTypes.deleting: return { ...state, deleting: true }
    case actionTypes.deleted: return { ...state, deleting: false, rsaKeys: action.data }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/RsaKeys.js